// extracted by mini-css-extract-plugin
module.exports = {"dialog":"SensorModal_dialog__27eGN","flex":"SensorModal_flex__2pUk9","column":"SensorModal_column__ML7Lg"};